module.exports = __webpack_public_path__ + "img/plus_o.831950dd.svg";